import { BodyPrimary, H2 } from '@liveauctioneers/hammer-ui-core/text';
import { CloseButton, ModalContent, ModalHeader, ModalTitle } from '@liveauctioneers/hammer-ui-core/modal/components';
import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { Modal } from '@liveauctioneers/hammer-ui-core/modal';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';

type Props = {
    setShow: (show: boolean) => void;
    show: boolean;
};

export const FileAClaimModal = ({ setShow, show }: Props) => {
    const { formatMessage } = useIntl();
    return (
        <Modal
            // TEMP FIX FOR VERY SMALL MOBILE SCREENS, FIX COMING TO HAMMER SOON
            className="[@media(max-width:400px)]:w-[100%!important]"
            handleClose={() => {
                setShow(false);
            }}
            preventScrollWhileOpen
            show={show}
            type="composable"
        >
            <CloseButton data-testid="close-button" />
            <ModalHeader>
                <ModalTitle>
                    <H2>{formatMessage({ id: 'purchaseProtectionPage.askForHelp.fileClaimModal.title' })}</H2>
                </ModalTitle>
            </ModalHeader>
            <ModalContent>
                <div className="space-y-md xsMax:pb-xl">
                    <div className="flex flex-wrap gap-x-2xs">
                        <BodyPrimary>
                            {formatMessage({ id: 'purchaseProtectionPage.askForHelp.fileClaimModal.toBegin' })}
                        </BodyPrimary>
                        <Link
                            href={`mailto:${formatMessage({ id: 'purchaseProtectionPage.askForHelp.fileClaimModal.email' })}`}
                        >
                            {formatMessage({ id: 'purchaseProtectionPage.askForHelp.fileClaimModal.email' })}
                        </Link>
                        <BodyPrimary>
                            {formatMessage({ id: 'purchaseProtectionPage.askForHelp.fileClaimModal.withDetails' })}
                        </BodyPrimary>
                    </div>

                    <ul className="list-disc pb-md pl-md">
                        <li>
                            <BodyPrimary>
                                {formatMessage({ id: 'purchaseProtectionPage.askForHelp.fileClaimModal.fullName' })}
                            </BodyPrimary>
                        </li>
                        <li>
                            <BodyPrimary>
                                {formatMessage({ id: 'purchaseProtectionPage.askForHelp.fileClaimModal.emailAddress' })}
                            </BodyPrimary>
                        </li>
                        <li>
                            <BodyPrimary>
                                {formatMessage({ id: 'purchaseProtectionPage.askForHelp.fileClaimModal.auctionHouse' })}
                            </BodyPrimary>
                        </li>
                        <li>
                            <BodyPrimary>
                                {formatMessage({
                                    id: 'purchaseProtectionPage.askForHelp.fileClaimModal.dateOfAuction',
                                })}
                            </BodyPrimary>
                        </li>
                        <li>
                            <BodyPrimary>
                                {formatMessage({
                                    id: 'purchaseProtectionPage.askForHelp.fileClaimModal.invoiceNumber',
                                })}
                            </BodyPrimary>
                        </li>
                        <li>
                            <BodyPrimary>
                                {formatMessage({ id: 'purchaseProtectionPage.askForHelp.fileClaimModal.lotNumber' })}
                            </BodyPrimary>
                        </li>
                        <li>
                            <BodyPrimary>
                                {formatMessage({
                                    id: 'purchaseProtectionPage.askForHelp.fileClaimModal.reasonForFiling',
                                })}
                            </BodyPrimary>
                        </li>
                        <li>
                            <BodyPrimary>
                                {formatMessage({
                                    id: 'purchaseProtectionPage.askForHelp.fileClaimModal.anySupportingDocuments',
                                })}
                            </BodyPrimary>
                        </li>
                    </ul>

                    <BodyPrimary>
                        {formatMessage({
                            id: 'purchaseProtectionPage.askForHelp.fileClaimModal.onceReceived',
                        })}
                    </BodyPrimary>
                </div>
            </ModalContent>
        </Modal>
    );
};
